import React from 'react';
import { Modal, Button, Empty, Typography } from 'antd';
import { NodeScenario, CreateScenarioImageResponse } from '../../api/models/Lifetree';

const { Text } = Typography;

interface ScenarioImagePreviewModalProps {
  open: boolean;
  onCancel: () => void;
  selectedScenario: NodeScenario | null;
  generatedImage: CreateScenarioImageResponse | null;
  approving: boolean;
  onApprove: () => void;
}

const ScenarioImagePreviewModal: React.FC<ScenarioImagePreviewModalProps> = ({
  open,
  onCancel,
  selectedScenario,
  generatedImage,
  approving,
  onApprove,
}) => {
  return (
    <Modal
      title="Xem ảnh Scenario"
      open={open}
      onCancel={onCancel}
      width={800}
      footer={
        generatedImage ? (
          <div style={{ textAlign: 'center' }}>
            <Button onClick={onCancel}>
              Hủy
            </Button>
            <Button 
              type="primary" 
              loading={approving}
              onClick={onApprove}
              style={{ marginLeft: 8 }}
            >
              Duyệt ảnh
            </Button>
          </div>
        ) : null
      }
    >
      {selectedScenario && (
        <div style={{ textAlign: 'center' }}>
          {generatedImage ? (
            // Show newly generated image
            <div>
              <img
                src={generatedImage.url}
                alt={selectedScenario.name}
                style={{ maxWidth: '100%', maxHeight: '60vh', marginBottom: 16 }}
              />
              <div style={{ background: '#f6ffed', padding: '12px', borderRadius: '6px', marginBottom: 16 }}>
                <Text type="secondary">
                  <strong>Mô tả:</strong> {generatedImage.description}
                </Text>
              </div>
            </div>
          ) : selectedScenario.imageUrl ? (
            // Show existing image
            <img
              src={selectedScenario.imageUrl}
              alt={selectedScenario.name}
              style={{ maxWidth: '100%', maxHeight: '80vh' }}
            />
          ) : (
            <Empty description="Chưa có ảnh" />
          )}
        </div>
      )}
    </Modal>
  );
};

export default ScenarioImagePreviewModal;
